import React from 'react'
import {Swiper, SwiperSlide} from 'swiper/react';
import Classes from '../../../../common/Classes';
import {Navigation, Pagination} from 'swiper/modules';
import {ImageTypes, SwiperBreakpoints, ItemType} from '../../../../common/Constants';
import ThumbnailWrapper from './ThumbnailWrapper';
import PropTypes from 'prop-types';
import Utils from '../../../../common/Utils';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import mixpanelConstants from '../../../../common/mixpanelConstants';
import {trackMixpanelEvent} from '../../../../common/MixpanelHelper';

const Carousel = (props) => {
    const { items, exhibitorId, translations, type, getDtmTag, mixpanelProps } = props;
    const brandColor = window.reactSettings.props.themes.brandPrimary;
    const navigationStyles = {
        '--swiper-navigation-color': brandColor
    }

    const getProductDtmAttributes = (product, exhibitorId) => {
        const attributes = {
            productId: product.id,
            exhibitorId,
            isNew: product.isNew,
        };
        attributes.isVideoAvailable = !!product.video?.id;
        return JSON.stringify(attributes);
    }

    const handleClickCarouselNavigation = () => {
        trackMixpanelEvent(mixpanelConstants.eventName.exhibitorClicked, {
            ...mixpanelProps,
            element: type === ItemType.Document ? mixpanelConstants.element.documentCarouselChevron : mixpanelConstants.element.productCarouselChevron
        });
    }

    return (
        <div>
            <Swiper
                breakpoints={SwiperBreakpoints}
                pagination= {{
                    el: `.${Classes.swiperPagination}`,
                    dynamicBullets: true,
                    renderBullet: function () {
                        return `<span class="swiper-pagination-bullet" style="background: ${window.reactSettings.props.themes.brandPrimary}"></span>`;
                    },
                    clickable: true
                }}
                slidesPerView={6}
                spaceBetween={16}
                navigation={{
                    nextEl: `.${Classes.swiperButtonNext}`,
                    prevEl: `.${Classes.swiperButtonPrev}`
                }}
                centerInsufficientSlides={true}
                modules={[Pagination, Navigation]}
            >
                {
                    type === ItemType.Document ? items.map((item, index) => (
                        <SwiperSlide key={index} onClick={()=>props.onClick(index, type)} clickable={true} >
                            <ThumbnailWrapper
                                src={Utils.getDocumentThumbnail(item.url)}
                                alt={translations.documents.documentImageAltText}
                                translations={translations}
                                imageDataDtm = {{
                                    tag: getDtmTag(ItemType.Document),
                                    attributes: JSON.stringify({
                                        documentName: Utils.removePdfFileNameExtension(item.title),
                                        documentType: item.type, exhibitorId})}}
                                type={ItemType.Document}
                                clipText= {item.type && translations.documents.documentType[item.type.toLowerCase()]}
                                mixpanelProps={{...props.mixpanelProps, documentName: Utils.removePdfFileNameExtension(item.title), documentType: item.type.toLowerCase(), type: mixpanelConstants.type.exhibitor}}
                            />
                        </SwiperSlide>
                    )) :
                    items.filter(item => !item.video?.id || (item.video?.id && item.video?.status === 'Successful')).map((item,index)=>(
                        <SwiperSlide key={item.id} onClick={()=>props.onClick(index, type)} clickable={true}>
                            <ThumbnailWrapper
                                src={`${Utils.getProductVideoOrImageUrl(item)}?${new Date().getTime()}`}
                                imageSize={ImageTypes.product}
                                alt={translations.products.productImageAltText}
                                translations={translations}
                                imageDataDtm = {{tag:getDtmTag(ItemType.Product), attributes: getProductDtmAttributes(item, exhibitorId)}}
                                type={ItemType.Product}
                                clipText= {item.isNew && translations.products.productCarouselClipText}
                                innovativeProductClipText={item.isInnovative && translations.products.innovativeClipText}
                                mixpanelProps={{...props.mixpanelProps, productId: item.id, productName: item.name}}
                                isVideoAvailable={!!item.video?.id}
                                product={item}
                            />
                        </SwiperSlide>
                    ))
                }
                <div className={`${Classes.controls}`}>
                    <div
                        role='button'
                        aria-label='Carousel previous button'
                        className={`${Classes.swiperButtonPrev}`}
                        style={navigationStyles}
                        data-dtm={type === ItemType.Document ? getDtmTag('documentCarouselChevron') : getDtmTag('productCarouselChevron')}
                        data-dtm-attributes={JSON.stringify({ exhibitorId })}
                        onClick={handleClickCarouselNavigation}
                    >
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </div>
                    <div
                        role='button'
                        aria-label='Carousel next button'
                        className={`${Classes.swiperButtonNext}`}
                        style={navigationStyles}
                        data-dtm={type === ItemType.Document ? getDtmTag('documentCarouselChevron') : getDtmTag('productCarouselChevron')}
                        data-dtm-attributes={JSON.stringify({ exhibitorId })}
                        onClick={handleClickCarouselNavigation}
                    >
                        <FontAwesomeIcon icon={faChevronRight} />
                    </div>
                    <div
                        role='button'
                        aria-label='Carousel pagination'
                        className={Classes.swiperPagination}
                        onClick={handleClickCarouselNavigation}
                    />
                </div>
            </Swiper>
        </div>
    );
}

Carousel.propTypes = {
    items:PropTypes.array.isRequired,
    exhibitorId: PropTypes.string.isRequired,
    translations: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    type: PropTypes.string,
    mixpanelProps: PropTypes.object,
    getDtmTag:PropTypes.func.isRequired,
}

export default Carousel;
